import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as signalR from '@microsoft/signalr';

export interface SignalRHubProps {
    url: string;
    onConnected?: () => void;
}

export abstract class SignalRHub<Props extends SignalRHubProps = SignalRHubProps, State = {}> extends React.Component<Props, State>{
    static propTypes = {
        url: PropTypes.string.isRequired,
        onCommected: PropTypes.func
    }

    private resolveConnected!: (connection: signalR.HubConnection) => void;
    private safeCallConnection: <T>(func: (c: signalR.HubConnection) => T | PromiseLike<T>) => Promise<T>

    constructor(props: Props) {
        super(props);
        let connected = new Promise<signalR.HubConnection>(resolve => this.resolveConnected = resolve);
        this.safeCallConnection = <T extends any>(func: (c: signalR.HubConnection) => T | PromiseLike<T>) => connected.then<T>(connection => func(connection));
    }

    componentDidMount() {
        let connection = new signalR.HubConnectionBuilder()
            .withUrl(this.props.url)
            .build();

        this.willConnect(connection);
        let started = connection.start();
        started.then(() => {
            this.didConnect();
            this.props.onConnected && this.props.onConnected();
            this.resolveConnected(connection);
        })
    }

    disconnectListeners: (() => void)[] = [];

    componentWillUnmount() {
        this.close();
    }

    render(): React.ReactNode {
        return null;
    }

    public addDisconnectListener(listener: () => void) {
        this.disconnectListeners.push(listener);
    }

    public removeDisconnectListener(listener: () => void) {
        this.disconnectListeners = this.disconnectListeners.filter(l => l !== listener);

    }
    public close() {
        this.disconnectListeners.forEach(l => l())
        this.safeCallConnection(c => c.stop());
    }

    protected willConnect(connection: signalR.HubConnection) { }
    protected didConnect() { }

    protected invoke<T>(method: string, ...args: any[]): Promise<T> {
        return this.safeCallConnection(c => c.invoke(method, ...args));
    }

    protected send(methodName: string, ...args: any[]) {
        return this.safeCallConnection(c => c.send(methodName, ...args));
    }
 }